import Translation from "components/Translation"

type UrlPreviewComponentProps = {
    image_url: string
    image_alt: string
    toggleShowUploadView: (toggle: boolean) => void
    replace_text: string
}

export default function UrlPreviewComponent(props: UrlPreviewComponentProps) {
    const {
        image_url,
        image_alt,
        toggleShowUploadView,
        replace_text
    } = props

    return (
        <div className="flex flex-col w-full">
            <div className="flex items-center border-2 border-gray-two border-dashed rounded-lg w-full bg-[#F9FAFE] py-3 justify-center">
                <img
                    src={image_url}
                    className="h-32 rounded-lg"
                    alt={image_alt}
                />
            </div>
            <button
                onClick={() => toggleShowUploadView(true)}
                className="flex w-fit gap-3 items-center bg-primary-light text-white px-6 py-3 rounded-lg text-lg justify-center mt-3"
            >
                <i className="feather-image text-xl" />
                <Translation
                    content_key={replace_text}
                    render_as="span"
                />
            </button>
        </div>
    )
}